// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__1YiPC","buttons":"Footer_buttons__25TKd"};